import moment from 'moment';
import { from } from 'rxjs';
import { groupBy, mergeMap, reduce, toArray, map, filter } from 'rxjs/operators';

export const setGroupMessages = (data, t, leadName) => subscribe => {
  from(data)
    .pipe(
      filter(
        f => f.action_type === undefined || f.action_type === '10' || f.action_type === '6' || f.action_type === '2'
      ),
      map(m => {
        if (m.action_type === '6') {
          m.text = t(`contacto:chat.leadViewData`, { name: leadName });
        }
        if (m.action_type === '10') {
          m.text = t(`contacto:chat.leadwhatsapp`, { name: leadName });
        }
        if (m.action_type === '2') {
          m.text = t(`contacto:chat.leadPhoneCall`);
        }
        return m;
      }),
      toArray(),
      map(messages =>
        messages.sort(function s(a, b) {
          return moment(a.date).diff(moment(b.date));
        })
      ),
      mergeMap(a =>
        from(a).pipe(
          groupBy(p => moment(p.date.split('T')[0]).format('YYYY-MM-DD')),
          mergeMap(group$ =>
            group$.pipe(
              reduce(
                (acc, cur) => {
                  return { ...acc, data: [...acc.data, cur] };
                },
                { key: group$.key, data: [] }
              ),
              map(dd => {
                dd.data.sort((aa, bb) => {
                  return moment(aa.date).diff(moment(bb.date));
                });
                return dd;
              })
            )
          )
        )
      ),
      toArray()
    )
    .subscribe(subscribe);
};

export const setGroupMessagesWithResponseMessage = data => subscribe => {
  from(data)
    .pipe(
      toArray(),
      map(messages =>
        messages.sort(function s(a, b) {
          return moment(a.date).diff(moment(b.date));
        })
      ),
      mergeMap(a =>
        from(a).pipe(
          groupBy(p => moment(p.date.split('T')[0]).format('YYYY-MM-DD')),
          mergeMap(group$ =>
            group$.pipe(
              reduce(
                (acc, cur) => {
                  return { ...acc, data: [...acc.data, cur] };
                },
                { key: group$.key, data: [] }
              ),
              map(dd => {
                dd.data.sort((aa, bb) => {
                  return moment(aa.date).diff(moment(bb.date));
                });
                return dd;
              })
            )
          )
        )
      ),
      toArray()
    )
    .subscribe(subscribe);
};

export const updateTabSelected = tab => tabs => {
  return tabs.map(t => {
    t.isSelected = tab.key === t.key;
    return t;
  });
};
